import React from 'react';
import { useFormikContext } from 'formik';
import { Typography, Grid } from '@material-ui/core';
import ReviewContactDetails from './ReviewContactDetails';
import ReviewServiceAddress from './ReviewServiceAddress';

export default function ReviewInquiry() {
  const { values: formValues } = useFormikContext();
  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Submission Summary
      </Typography>
      <Grid container spacing={2}>
        <ReviewContactDetails formValues={formValues} />
        <ReviewServiceAddress formValues={formValues} />
      </Grid>
    </React.Fragment>
  );
}
